import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { SelectList } from "../../../../../components/Functional";
import { LIST_TYPES } from "../../../../../constants/listTypes";
import { FETCH_LIST_ITEMS as fetchListItems } from "../../../../../graphql/query/ListItems";

const Actions = props => {
  const { listId, workingListId } = props || {};
  const navigate = useNavigate();
  const sourceTypeId = listId ? LIST_TYPES.INSTANCE : LIST_TYPES.INSTANCE_WORKING;
  const listItemIds = useMemo(() => {
    const selected = props.formik?.values?.selected?.ids || [];
    return Object.entries(selected).map?.(([_, item]) => item.id);
  }, [props.formik]);

  return (
    <div className="grid grid-flow-col gap-4">
      <SelectList.RemoveSelected
        {...props}
        listId={listId || workingListId}
        listItemIds={listItemIds}
      />
      <SelectList.ClearList {...props} listId={listId || workingListId} />
      <SelectList.CopyList
        {...props}
        listId={listId || workingListId}
        typeId={sourceTypeId}
        sourceTypeId={sourceTypeId}
        onSuccess={() => {
          props?.onSuccess?.();
          navigate("/instance?status=imageSelectListWorking");
        }}
      />
      {listId ? (
        <SelectList.ExitEditMode
          onSuccess={() => {
            props?.onSuccess?.();
            navigate("/instance?status=selectListSaved");
          }}
        />
      ) : (
        <SelectList.SaveList
          {...{
            ...props,
            typeId: LIST_TYPES.INSTANCE,
            onSuccess: () => {
              props?.onSuccess?.();
              navigate("/instance?status=selectListSaved");
            },
          }}
        />
      )}
    </div>
  );
};

const tableProps = props => {
  const { listId, workingListId } = props || {};
  // Prioritize listId (saved list) over workingListId (working list)
  const finalListId = listId || workingListId;

  const tableProps = {
    dataKey: "listItems",
    fetchPolicy: "network-only",
    FETCH_QUERY: fetchListItems({
      item: {
        edition: {
          id: true,
          number: true,
          year: true,
          artwork: {
            title: true,
            imagesSummary: { imgT: true, imgX: true },
            artists: {
              name: true,
            },
          },
        },
        status: {
          name: true,
        },
        editionNumber: true,
      },
    }),
    skip: () => !finalListId,
    variables: {
      listId: finalListId,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
